var TWEEN = require('@tweenjs/tween.js');
import SVG from 'svg.js';

$.fn.FS_Graphics = function()
{
  var self = this;
  self.art = undefined;
  self.counts = {
    sante: undefined,
    education: undefined,
    soutien: undefined,
    arts: undefined,
    philagora: undefined,
  };

  self.Count = function(el)
  {
    var count = this;
    count.el = el;
    count.current = 0;
    count.total = 0;
    count.tween = undefined;
    count.hasRun = false;

    count.tick = function(time)
    {
      count.tween.update(time);
      if (!count.hasEnded){
        requestAnimationFrame(count.tick);
      }
    };

    count.run = function()
    {
      if (count.hasRun) {
        return;
      }
      let locale = $('html').attr('lang') == 'en' ? 'en-CA' : 'fr-CA';
      count.el.text('1');
      count.hasRun = true;
      count.tween = new TWEEN.Tween(count)
        .to({current: count.total}, 1500)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(function(){
          count.el.plain(Math.round(count.current).toLocaleString(locale));
        })
        .onComplete(function(){
          count.hasEnded = true;
        })
        .start();
      requestAnimationFrame(count.tick);
    };

    return function(){
      count.total = parseInt(count.el.text().replace(/ /g, ''), 10);
      count.el.plain('0');
      return count;
    }();
  };

  self.run = function()
  {
    SVG.get('fs2-lines').animate(450, '>', 0).opacity(1);
    SVG.get('fs2-info').animate(450, '>', 150).opacity(1);
    SVG.get('fs2-counts').animate(450, '>', 250).opacity(1);
    setTimeout(function(){
      self.counts.sante.run();
      self.counts.education.run();
      self.counts.soutien.run();
      self.counts.arts.run();
      self.counts.philagora.run();
    }, 250);
  };

  return function()
  {
    /* Load SVG file */
    SVG.get('fs2-lines').opacity(0);
    SVG.get('fs2-info').opacity(0);
    SVG.get('fs2-counts').opacity(0);
    self.counts.sante = new self.Count(SVG.get('count-sante'));
    self.counts.education = new self.Count(SVG.get('count-education'));
    self.counts.soutien = new self.Count(SVG.get('count-soutien'));
    self.counts.arts = new self.Count(SVG.get('count-arts'));
    self.counts.philagora = new self.Count(SVG.get('count-philagora'));
    return self;
  }();
};
